module.exports = __webpack_public_path__ + "static/media/trenitalia-card.e244bd59.png";